var map = {
	"./apple.png": 406,
	"./baby.png": 407,
	"./ball.png": 408,
	"./banana.png": 409,
	"./bed.png": 410,
	"./bicycle.png": 411,
	"./boat.png": 412,
	"./book.png": 413,
	"./boot.png": 414,
	"./cat.png": 415,
	"./chair.png": 416,
	"./check.png": 88,
	"./cow.png": 417,
	"./crocodile.png": 418,
	"./cross.png": 419,
	"./cup.png": 420,
	"./doll.png": 421,
	"./dysmate-logo-hvit-small.png": 422,
	"./ear.png": 423,
	"./elephant.png": 424,
	"./eye.png": 425,
	"./finger.png": 426,
	"./fireengine.png": 427,
	"./fish.png": 428,
	"./flower.png": 429,
	"./flowers.png": 430,
	"./foot.png": 431,
	"./gloves.png": 432,
	"./horse.png": 433,
	"./house.png": 434,
	"./icecream.png": 435,
	"./jeans.png": 436,
	"./key.png": 437,
	"./laptop-icon.png": 137,
	"./lion.png": 438,
	"./literate-regular-light.png": 439,
	"./logo-white.png": 53,
	"./motorcycle.png": 440,
	"./nose.png": 441,
	"./package.png": 442,
	"./pc-icon.png": 135,
	"./plane.png": 443,
	"./plowtruck.png": 444,
	"./porrige.png": 445,
	"./purse.png": 446,
	"./rabbit.png": 447,
	"./rapidNaming/bamse.png": 448,
	"./rapidNaming/blabamse.png": 36,
	"./rapidNaming/blaeple.png": 38,
	"./rapidNaming/blagenser.png": 37,
	"./rapidNaming/blasykkel.png": 39,
	"./rapidNaming/blatommel.png": 26,
	"./rapidNaming/elefant.png": 449,
	"./rapidNaming/eple.png": 450,
	"./rapidNaming/genser.png": 451,
	"./rapidNaming/grabamse.png": 19,
	"./rapidNaming/graeple.png": 23,
	"./rapidNaming/gragenser.png": 22,
	"./rapidNaming/grasykkel.png": 25,
	"./rapidNaming/gratommel.png": 24,
	"./rapidNaming/gronnbamse.png": 48,
	"./rapidNaming/gronneple.png": 50,
	"./rapidNaming/gronngenser.png": 49,
	"./rapidNaming/gronnsykkel.png": 29,
	"./rapidNaming/gronntommel.png": 51,
	"./rapidNaming/oransjebamse.png": 40,
	"./rapidNaming/oransjeeple.png": 27,
	"./rapidNaming/oransjegenser.png": 41,
	"./rapidNaming/oransjesykkel.png": 43,
	"./rapidNaming/oransjetommel.png": 42,
	"./rapidNaming/paraply.png": 452,
	"./rapidNaming/prinsesse.png": 453,
	"./rapidNaming/rodbamse.png": 44,
	"./rapidNaming/rodeple.png": 45,
	"./rapidNaming/rodgenser.png": 28,
	"./rapidNaming/rodsykkel.png": 47,
	"./rapidNaming/rodtommel.png": 46,
	"./rapidNaming/stoevsuger.png": 454,
	"./rapidNaming/sykkel.png": 455,
	"./rapidNaming/tannboerste.png": 456,
	"./rapidNaming/tommel.png": 457,
	"./reflex.png": 458,
	"./saft.png": 459,
	"./server-icon.png": 136,
	"./shoe.png": 460,
	"./ski.png": 461,
	"./spoon.png": 462,
	"./sun.png": 463,
	"./sweater.png": 464,
	"./teddy.png": 465,
	"./telephone.png": 466,
	"./tractor.png": 467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;